<template>
    <div class="ch-container">
      <el-card>
        <template slot="header">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/help' }">帮助中心</el-breadcrumb-item>
            <!-- <el-breadcrumb-item :to="{ path: '/correct' }" v-if="typeNumber == '3'">更正公告</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/result' }" v-if="typeNumber == '4'">结果公告</el-breadcrumb-item> -->
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </template>
        <!-- 招标公告详情  -->
        <div class="ch-info-box" >
          <div class="ch-info-title">{{helpDetail.title}}</div>
          <div class="ch-info-tabel">
            <!-- <div class="ch-into-item">
              <div class="ch-info-item-td ch-info-item-label">摘要</div>
              <div class="ch-info-item-td ch-info-item-value">
                {{helpDetail.summary}}
              </div>
            </div> -->
            <div class="ch-into-item">
              <!-- <div class="ch-info-item-td ch-info-item-label">详情</div> -->
              <div style="width: 100%;overflow: hidden;" class="ch-info-item-td ch-info-item-value" v-html="helpDetail.content"></div>
            </div>
           
          </div>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
    import home from "@/api/home"
    export default {
        data(){
            return {
                helpDetail:{}
            }
        
        },
        created(){
            home.helpCenterInfo({id:this.$route.query.id}).then(res=>{
                console.log("帮助详情:",res)
                this.helpDetail=res.data
            })
        }
    }
  </script>
  <style>
      img{
      width: 100% !important;
    }
  </style>
  <style lang="less" scoped>
    
  .ch-info-box {
    width: 880px;
    padding: 25px 0;
    margin: auto;
  }
  
  .ch-info-title {
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    line-height: 42px;
    margin-bottom: 35px;
    text-align: center;
  }
  
  .ch-info-tabel {
    border: solid 1px #efefef;
  }
  
  .ch-into-item {
    display: flex;
    align-items: center;
    >.ch-info-item-td {
      padding: 20px 30px;
      box-sizing: border-box;
    }
  
    >.ch-info-item-td+.ch-info-item-td {
      border-left: solid 1px #efefef;
    }
  }
  
  .ch-info-item-label {
    /* background-color: #f9f9f9; */
    align-items: center;
    font-size: 14px;
    width: auto;
    height: auto;
    color: #343434;
  }
  
  .ch-info-item-value {
    font-size: 14px;
    color: #343434;
    flex: 1;
  }
  
  .ch-into-item+.ch-into-item {
    border-top: solid 1px #efefef;
  }
  
  .ch-info-buttons {
    margin-top: 35px;
    text-align: center;
  
    .el-button {
      padding-left: 40px;
      padding-right: 40px;
    }
  }</style>